import { Key } from 'react'
import { Item } from '@react-stately/collections'
import { Button } from 'blaze-ui/Button'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { Menu } from 'components/Menu/Menu'

interface AddMoreDropdownProps {
  onAdd: (isBlank: boolean) => void
}

export const AddMoreDropdown = ({ onAdd }: AddMoreDropdownProps) => {
  return (
    <DropdownTrigger placement="bottom-start">
      <Button withChevron="down" variant="secondary" size="lg" aria-label="Add more">
        Add More
      </Button>
      {(close: () => void) => (
        <Menu
          onAction={(key: Key) => {
            onAdd(key === 'blank')
            close()
          }}
          aria-label="Add another post"
        >
          <Item key="ai" textValue="Add AI post">
            Add AI post
          </Item>
          <Item key="blank" textValue="Add Blank post">
            Add Blank post
          </Item>
        </Menu>
      )}
    </DropdownTrigger>
  )
}
